import { Box } from "@mui/material";

interface FormFieldIconBoxProps {
  icon: JSX.Element;
}

export const FormFieldIconBox = (props: FormFieldIconBoxProps) => {
  const { icon } = props;

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "28px",
        height: "28px",
        borderRadius: "5px",
        backgroundColor: theme.palette.secondary[6],
        boxShadow: `inset 0 0 0 0.5px ${theme.palette.secondary[5]}`,
        fontSize: "22px",
        color: theme.palette.secondary[3],
      })}
    >
      {icon}
    </Box>
  );
};
